import { FC } from 'react';
import cx from 'classnames/bind';

import styles from './Link.module.scss';

interface LinkProps {
  href: string;
  text: string;
  className?: string;
  target?: string;
}

const cn = cx.bind(styles);

const Link: FC<LinkProps> = ({ href, text, className, target = '_blank' }) => (
  <a
    target={target}
    rel="noreferrer"
    className={cn('link', className)}
    href={href}
  >
    {text}
  </a>
);

export default Link;
